import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Button, Checkbox, Box } from '@kufox/mui';
import { styled } from '@kufox/mui/emotion';
import InputSendCode from '../../components/InputSendCode';
import VoiceCode from '../../components/voiceCode';
import { NAMESPACE } from '../constants';
import { useLang } from '../../hookTool';

const { FormItem } = Form;

const ForbidSMS = styled(Box)`
  font-size: 14px;
  line-height: 22px;
  color: ${({ theme }) => theme.colors.text};
  margin-top: 8px;
  text-align: right;
  span {
    cursor: pointer;
  }
`;

const SMS = (props) => {
  const {
    validationType,
    onSuccess,
    verifyCanNotUseClick,
    trackResultParams,
    isSub = false,
  } = props;
  const [form] = Form.useForm();
  const [disable, setDisable] = useState(false);

  const dispatch = useDispatch();
  const {
    smsRetryAfterSeconds,
    token,
    gfaBtnLoading,
    loadingSms,
    sendChannel = '',
    countryCode = '',
  } = useSelector((state) => state[NAMESPACE]);

  const { t } = useLang();

  const handleSubmit = (values) => {
    dispatch({
      type: `${NAMESPACE}/validate`,
      payload: {
        ...values,
        validationType,
      },
      onSuccess,
      trackResultParams,
    });
  };

  const handleSendCode = () => {
    dispatch({
      type: `${NAMESPACE}/sendSms`,
      payload: {
        sendChannel: 'MY_SMS',
      },
    });
  };

  const onSendVoice = useCallback(() => {
    return dispatch({
      type: `${NAMESPACE}/sendSms`,
      payload: {
        sendChannel: 'MY_VOICE',
      },
    });
  }, []);

  const offDisabled = useCallback(() => {
    setDisable(false);
    dispatch({
      type: `${NAMESPACE}/update`,
      payload: {
        smsRetryAfterSeconds: { time: 0 },
      },
    });
  }, [dispatch]);

  useEffect(() => {
    if (smsRetryAfterSeconds && smsRetryAfterSeconds.time > 0) {
      setDisable(true);
    }
  }, [smsRetryAfterSeconds]);

  return (
    <Form form={form} onFinish={handleSubmit}>
      <FormItem
        name="code"
        requiredMark={false}
        rules={[{ required: true, message: t('form.required') }]}
        label={t('gfa.vc.sms')}
      >
        <InputSendCode
          loading={loadingSms}
          disabled={disable}
          countTimeOver={offDisabled}
          onSendCode={handleSendCode}
          countTime={sendChannel && sendChannel === 'MY_SMS' ? smsRetryAfterSeconds : null}
          autoFocus
          size="large"
        />
      </FormItem>
      <FormItem initialValue={false} valuePropName="checked" name="trustDevice">
        <Checkbox>{t('gfa.trust')}</Checkbox>
      </FormItem>
      <Button
        fullWidth
        htmlType="submit"
        size="large"
        loading={gfaBtnLoading}
        disabled={gfaBtnLoading}
      >
        {t('gfa.btn')}
      </Button>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <VoiceCode
          countryCode={countryCode}
          countTime={sendChannel && sendChannel === 'MY_VOICE' ? smsRetryAfterSeconds : null}
          loading={loadingSms}
          disable={disable}
          onTimeOver={offDisabled}
          onSend={onSendVoice}
        />
        {verifyCanNotUseClick && !isSub ? (
          <ForbidSMS>
            <span
              onClick={() => {
                verifyCanNotUseClick('SMS', token);
              }}
            >
              {t('phone.unvaliable')}
            </span>
          </ForbidSMS>
        ) : null}
      </div>
    </Form>
  );
};

export default SMS;
